import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/netmoove-01.png';

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  // Menü dışına tıklanınca kapansın
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header ref={navRef} className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur shadow-sm">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-4 py-4">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="h-6 md:h-8 w-auto" />
        </Link>

        {/* Hamburger Menü (mobil) */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-white text-2xl md:hidden z-50"
          aria-label="Menü öffnen"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        {/* Masaüstü Menü */}
        <ul className="hidden md:flex items-center gap-6 text-sm font-medium">
          {[
            { path: '/', label: 'Home' },
            { path: '/ueber', label: 'Über' },
            { path: '/services', label: 'Leistungen' },
            { path: '/kontakt', label: 'Kontakt' },
          ].map((item, idx) => (
            <li key={idx}>
              <Link
                to={item.path}
                className="text-white no-underline hover:text-fuchsia-400 transition duration-200"
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/lass-sprechen"
              className="bg-[#c1ff72] text-black no-underline px-4 py-3 rounded-full font-semibold transform transition-transform duration-200 hover:scale-105"
            >
              Hast du Ideen?
            </Link>
          </li>
        </ul>
      </nav>

      {/* Mobil Menü */}
      {menuOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-md px-6 py-4 space-y-4 text-center shadow-lg">
          {[
            { path: '/', label: 'Home' },
            { path: '/ueber', label: 'Über' },
            { path: '/services', label: 'Leistungen' },
            { path: '/kontakt', label: 'Kontakt' },
            { path: '/lass-sprechen', label: 'Lass Sprechen', special: true },
          ].map((item, idx) => (
            <div key={idx}>
              <Link
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`block text-lg no-underline font-medium ${item.special
                  ? 'bg-fuchsia-600 text-white py-2 rounded-full hover:bg-fuchsia-700'
                  : 'text-white hover:text-fuchsia-400'
                  } transition`}
              >
                {item.label}
              </Link>
            </div>
          ))}
        </div>
      )}
    </header>
  );
};

export default NavBar;
